import { gql } from '@apollo/client';

export const LIST_TAXONOMIES = gql`
    query ($input: GetListDTO!) {
        listTaxonomies(input: $input) {
            message
            taxonomies {
                _id
                name
            }
            pagination {
                total
                hasNextPage
            }
        }
    }
`;

export const LIST_TAXONOMY = gql`
    query ($id: String!) {
        listTaxonomy(id: $id) {
            message
            taxonomy {
                _id
                name
                taxons {
                    name
                    uuid
                    metaTitle
                    metaDescription
                    metaKeywords
                    image
                    description
                    nestedUnder
                    children {
                        name
                        uuid
                        metaTitle
                        metaDescription
                        metaKeywords
                        image
                        description
                        nestedUnder
                        children {
                            name
                            uuid
                            metaTitle
                            metaDescription
                            metaKeywords
                            image
                            description
                            nestedUnder
                        }
                    }
                }
            }
        }
    }
`;
